var __jsx = React.createElement;
import React from 'react';
import { ScopeBuilder } from '@gtintel/platform-scope-builder';
import { RouteRolesEnum } from '@gtintel/platform-types';
import AppLayout from '../../../components/AppLayout';
var ScopeBuilderAdminPage = function ScopeBuilderAdminPage() {
  return __jsx(AppLayout, {
    title: "Scope Builder",
    menuSelected: ['4']
  }, __jsx(ScopeBuilder, {
    currentUserRole: RouteRolesEnum.ADMIN
  }));
};
export default ScopeBuilderAdminPage;